/* GENERATED by scripts/gen-data.mjs — film scene "f-evaluate" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_EVALUATE: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "frame",
      "id": "ds",
      "x": 14,
      "y": 16,
      "w": 206,
      "h": 268,
      "lKey": "films:f-evaluate.items.ds.l"
    },
    {
      "k": "box",
      "id": "s1",
      "x": 26,
      "y": 52,
      "w": 182,
      "h": 40,
      "lKey": "films:f-evaluate.items.s1.l"
    },
    {
      "k": "box",
      "id": "s2",
      "x": 26,
      "y": 98,
      "w": 182,
      "h": 40,
      "lKey": "films:f-evaluate.items.s2.l"
    },
    {
      "k": "box",
      "id": "s3",
      "x": 26,
      "y": 144,
      "w": 182,
      "h": 40,
      "lKey": "films:f-evaluate.items.s3.l"
    },
    {
      "k": "box",
      "id": "s4",
      "x": 26,
      "y": 190,
      "w": 182,
      "h": 40,
      "lKey": "films:f-evaluate.items.s4.l"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "s2",
      "to": "mdl",
      "dash": true
    },
    {
      "k": "box",
      "id": "mdl",
      "x": 244,
      "y": 164,
      "w": 140,
      "h": 56,
      "lKey": "films:f-evaluate.items.mdl.l"
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "mdl",
      "to": "cm",
      "dash": true
    },
    {
      "k": "frame",
      "id": "cm",
      "x": 412,
      "y": 16,
      "w": 214,
      "h": 196,
      "lKey": "films:f-evaluate.items.cm.l"
    },
    {
      "k": "chip",
      "id": "vp",
      "x": 424,
      "y": 56,
      "w": 92,
      "h": 52,
      "lKey": "films:f-evaluate.items.vp.l",
      "sKey": "films:f-evaluate.items.vp.s"
    },
    {
      "k": "chip",
      "id": "fp",
      "x": 524,
      "y": 56,
      "w": 90,
      "h": 52,
      "lKey": "films:f-evaluate.items.fp.l",
      "sKey": "films:f-evaluate.items.fp.s"
    },
    {
      "k": "chip",
      "id": "fn",
      "x": 424,
      "y": 120,
      "w": 92,
      "h": 52,
      "lKey": "films:f-evaluate.items.fn.l",
      "sKey": "films:f-evaluate.items.fn.s"
    },
    {
      "k": "chip",
      "id": "vn",
      "x": 524,
      "y": 120,
      "w": 90,
      "h": 52,
      "lKey": "films:f-evaluate.items.vn.l",
      "sKey": "films:f-evaluate.items.vn.s"
    },
    {
      "k": "box",
      "id": "gt",
      "x": 412,
      "y": 228,
      "w": 104,
      "h": 56,
      "lKey": "films:f-evaluate.items.gt.l"
    },
    {
      "k": "box",
      "id": "hq",
      "x": 528,
      "y": 228,
      "w": 98,
      "h": 56,
      "lKey": "films:f-evaluate.items.hq.l"
    },
    {
      "k": "wire",
      "id": "w3",
      "from": "fp",
      "to": "hq",
      "dash": true
    }
  ],
  "steps": [
    {
      "on": [
        "ds",
        "s1",
        "s2",
        "s3",
        "s4"
      ],
      "hot": [
        "ds"
      ],
      "capKey": "films:f-evaluate.steps.0.cap"
    },
    {
      "on": [
        "ds",
        "s1",
        "s2",
        "s3",
        "s4",
        "mdl",
        "w1"
      ],
      "hot": [
        "mdl",
        "w1"
      ],
      "capKey": "films:f-evaluate.steps.1.cap"
    },
    {
      "on": [
        "ds",
        "s1",
        "s2",
        "s3",
        "s4",
        "mdl",
        "w1",
        "cm",
        "vp",
        "fp",
        "fn",
        "vn",
        "w2"
      ],
      "hot": [
        "vp",
        "fp",
        "fn",
        "vn"
      ],
      "capKey": "films:f-evaluate.steps.2.cap"
    },
    {
      "on": [
        "ds",
        "s1",
        "s2",
        "s3",
        "s4",
        "mdl",
        "w1",
        "cm",
        "vp",
        "fp",
        "fn",
        "vn",
        "w2",
        "gt"
      ],
      "hot": [
        "gt"
      ],
      "capKey": "films:f-evaluate.steps.3.cap"
    },
    {
      "on": [
        "ds",
        "s1",
        "s2",
        "s3",
        "s4",
        "mdl",
        "w1",
        "cm",
        "vp",
        "fp",
        "fn",
        "vn",
        "w2",
        "gt",
        "hq",
        "w3"
      ],
      "hot": [
        "hq",
        "w3"
      ],
      "capKey": "films:f-evaluate.steps.4.cap"
    }
  ]
};
